module.exports = {"Directed Energy Deposition (DED)":"DED - Directed Energy Deposition","Direct Metal Laser Sintering (DMLS)":"DMLS - Direct Metal Laser Sintering","Fused Deposition Modeling (FDM)":"FDM - Fused Deposition Modeling","Laminated Object Manufacturing (LOM)":"LOM - Laminated Object Manufacturing","Powder Bed Fusion (PBF)":"PBF - Powder Bed Fusion","Selective Laser Sintering (SLS)":"SLS - Selective Laser Sintering","Solid Ground Curing (SGC)":"SGC - Solid Ground Curing","Stereolithography (SLA)":"SLA - Stereolithography"}


//////////////////
// WEBPACK FOOTER
// ./src/config/additiveManufacturingCapabilities.json
// module id = 5675
// module chunks = 1